import { WeeklyAvailability } from '../models';

/**
 * Week days constant
 */
export const WEEK_DAYS = [
  {
    label: $localize`Monday`,
    /**
     * Database key
     */
    key: 'mon' as keyof WeeklyAvailability,
    selected: true,
  },
  {
    label: $localize`Tuesday`,
    key: 'tue' as keyof WeeklyAvailability,
    selected: true,
  },
  {
    label: $localize`Wednesday`,
    key: 'wed' as keyof WeeklyAvailability,
    selected: true,
  },
  {
    label: $localize`Thursday`,
    key: 'thu' as keyof WeeklyAvailability,
    selected: true,
  },
  {
    label: $localize`Friday`,
    key: 'fri' as keyof WeeklyAvailability,
    selected: true,
  },
  {
    label: $localize`Saturday`,
    key: 'sat' as keyof WeeklyAvailability,
    selected: false,
  },
  {
    label: $localize`Sunday`,
    key: 'sun' as keyof WeeklyAvailability,
    selected: false,
  },
];
